import React from 'react';
import SEO from '../../components/Seo';
import ServiceCard from '../../components/ServiceCard';

import { allServices, otherTexts } from '../../data/services';
import { Link } from 'gatsby';
import { useVoice } from '../../hooks/useVoice';
import Bounce from 'react-reveal/Bounce';
import Fade from 'react-reveal/Fade';

function Services() {
  const Speak = useVoice();
  return (
    <div id='services'>
      <SEO title='Solutions | Solaric' />
      <div className='heading-links BgServices'>
        <Bounce>
          <h1>Solutions</h1>
        </Bounce>
        <h6>
          <Link to='/' className='mr-2'>
            Home{' '}
          </Link>
          <span>{'>'}</span> Solutions
        </h6>
      </div>

      <div className='container s-container mt-5' id='models'>
        <div className='row header-title text-center'>
          <div className='col-md-8 col-lg-6 mx-auto'>
            <Bounce>
              <h2 className='mt-5'>
                <span> Build Your Own Solution</span>
              </h2>
            </Bounce>
            <Fade>
              <p>
                {otherTexts.plan} <Speak text={otherTexts.plan} />
              </p>
            </Fade>
          </div>
        </div>
      </div>
      <div className='container mt-5'>
        <div className='row'>
          {allServices.map((service, index) => (
            <div className='col-md-6' key={service.id}>
              <ServiceCard count={index + 1} service={service} />
            </div>
          ))}
        </div>
      </div>

      <div className='container' id='comparison'>
        <div className='row header-title text-center' style={{ marginTop: '-3rem' }}>
          <div className='col-md-8 col-lg-6 mx-auto'>
            <Bounce>
              <h2 className='mt-5'>
                <span> Selecting Appropriate Financial Model</span>
              </h2>
            </Bounce>
          </div>
        </div>
        <div className='row comparison mt-4'>
          {/* <h5>The strategic reasons to choose OpEx model over the CapEx model are the following:</h5> */}
          <div className='col-md-6'>
            <ul className='list-group'>
              <span>OpEx</span>
              <li className='list-group-item'>Significantly low Cost of Energy- BDT 3/ KWh (for 20 years)</li>
              <li className='list-group-item'> Low cost loan from IDCOL/Other Financial Institutions </li>
              <li className='list-group-item'>Payback within 4/5 years and free electricity after 10 years</li>
              <li className='list-group-item'>Sell excess electricity at grid rate through net metering </li>
            </ul>
          </div>
          <div className='col-md-6'>
            <ul className='list-group'>
              <span>CapEx</span>
              <li className='list-group-item'>
                No Liability- Roof owner assumes no liability (technical or financial)
              </li>
              <li className='list-group-item'> Hassle free Operation for 20 years </li>
              <li className='list-group-item'>Guaranteed output from Day 1</li>
              <li className='list-group-item'>Service provider ensures smooth maintenance and operation </li>
            </ul>
          </div>
        </div>
      </div>

      <div className='mb-5 mt-5'>.</div>
    </div>
  );
}

export default Services;
